<section class="owner-details-page position-relative overflow-hidden py-4 py-lg-5">
  <div class="container position-relative z-1">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">
      {{ alert.message }}
    </ngb-alert>

    <div class="text-center mb-4 mb-lg-5">
      <h1 class="page-title display-5 fw-bold mb-3">Your profile</h1>
      <app-progress-stepper
        [currentStep]="RegistrationFlowStep.UserDetails"
        [label]="'Complete your details'">
      </app-progress-stepper>
    </div>

    <form #ownerDetailForm="ngForm" (ngSubmit)="updateOwnerDetails()" novalidate>
      <div class="owner-details-form row g-4">

        <!-- Personal details column -->
        <div class="col-12 col-md-6">

          <div class="form-card h-100 p-4">
            <!-- Title -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="title">Title</label>
              <select #title="ngModel" class="form-select field-input"
                [class.is-invalid]="title.touched && title.invalid"
                id="title" name="title" [(ngModel)]="keeperDetailModel.title">
                <option [ngValue]="null" disabled>Please choose an option</option>
                <option *ngFor="let titleEntry of UserTitles" [ngValue]="titleEntry">{{ titleEntry }}</option>
              </select>
            </div>
            <!-- Name -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="firstName">Name*</label>
              <input #firstName="ngModel" class="form-control field-input"
                [class.is-invalid]="firstName.touched && !firstName.valid"
                id="firstName" name="firstName"
                [(ngModel)]="keeperDetailModel.firstName"
                placeholder="Your first name"
                (blur)="keeperDetailModel.firstName = keeperDetailModel.firstName.trim()"
                required type="text"/>
              <div *ngIf="firstName.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
            </div>
            <!-- Last name -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="lastName">Last name*</label>
              <input #lastName="ngModel" class="form-control field-input"
                [class.is-invalid]="lastName.touched && !lastName.valid"
                id="lastName" name="lastName"
                [(ngModel)]="keeperDetailModel.lastName"
                placeholder="Your last name"
                (blur)="keeperDetailModel.lastName = keeperDetailModel.lastName.trim()"
                required type="text"/>
              <div *ngIf="lastName.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
            </div>
            <!-- Date of birth -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="dateOfBirth">Date of birth</label>
              <div class="input-group">
                <input #dateOfBirth="ngbDatepicker" #dateOfBirthModel="ngModel"
                  class="form-control field-input"
                  [class.is-invalid]="dateOfBirthModel.touched && dateOfBirthModel.invalid"
                  name="dateOfBirth" [(ngModel)]="dateOfBirthValue"
                  placeholder="dd/mm/yyyy"
                  [startDate]="{year: 1990, month: 12}"
                  ngbDatepicker [maxDate]="today" [minDate]="minDate"/>
                <button class="btn btn-outline-secondary calendar" (click)="dateOfBirth.toggle()" type="button">
                  <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                </button>
              </div>
            </div>
            <!-- Gender -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium">Gender</label>
              <div class="d-flex gap-4 align-items-center py-1">
                <label class="d-flex align-items-center gap-2 cursor-pointer mb-0" *ngFor="let genderEntry of Genders">
                  <input type="radio" class="form-check-input gender-radio mt-0"
                    name="gender" [(ngModel)]="keeperDetailModel.gender" [value]="genderEntry"/>
                  <span class="small">{{ genderEntry }}</span>
                </label>
              </div>
            </div>
            <!-- Phone -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="phoneNumber">Phone number*</label>
              <input #phoneNumber="ngModel" class="form-control field-input"
                [class.is-invalid]="phoneNumber.touched && !phoneNumber.valid"
                id="phoneNumber" name="phoneNumber"
                [(ngModel)]="keeperDetailModel.mainPhoneNumber"
                placeholder="Your phone number"
                (blur)="keeperDetailModel.mainPhoneNumber = keeperDetailModel.mainPhoneNumber.trim()"
                [pattern]="validationPatterns.telephone" required type="text"/>
              <div *ngIf="phoneNumber.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
              <div *ngIf="phoneNumber.errors?.pattern && !phoneNumber.errors?.minlength" class="field-error small">{{ errorStrings.telephoneInvalid }}</div>
            </div>
            <!-- Second phone -->
            <div class="d-flex flex-column gap-1">
              <label class="field-label fw-medium" for="secondPhoneNumber">Second phone number</label>
              <input #secondPhoneNumber="ngModel" class="form-control field-input"
                [class.is-invalid]="secondPhoneNumber.touched && !secondPhoneNumber.valid"
                id="secondPhoneNumber" name="secondPhoneNumber"
                [(ngModel)]="keeperDetailModel.secondPhoneNumber"
                placeholder="Your second phone number"
                (blur)="keeperDetailModel.secondPhoneNumber = keeperDetailModel.secondPhoneNumber.trim()"
                [pattern]="validationPatterns.telephone" type="text"/>
              <div *ngIf="secondPhoneNumber.errors?.pattern && !secondPhoneNumber.errors?.minlength" class="field-error small">{{ errorStrings.telephoneInvalid }}</div>
            </div>
          </div>

        </div>

        <!-- Address column -->
        <div class="col-12 col-md-6">

          <div class="form-card h-100 p-4">
            <!-- Postcode search -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="postcodeCheck"><strong>Start typing your postcode</strong></label>
              <input class="form-control field-input"
                id="postcodeCheck" name="postcodeCheck"
                [(ngModel)]="postcodeCheck"
                placeholder="Your postcode"
                (input)="onPostCodeCheckChanges($event)"
                (keydown.enter)="focusOnSelect()"
                type="text"/>
              <div *ngIf="isPostcodeInvalid" class="field-error small">The provided postcode is invalid!</div>
              <div *ngIf="addressesSelectList.length > 0" class="d-flex flex-column gap-1 mt-2">
                <label class="field-label fw-medium">Select your address</label>
                <select class="form-select field-input" id="selectedAddress" name="selectedAddress"
                  [(ngModel)]="selectedAddress" (ngModelChange)="onSelectAddressChanged($event)">
                  <option [ngValue]="null" disabled>Select address...</option>
                  <option *ngFor="let addressOption of addressesSelectList" [ngValue]="addressOption">{{ getAddressLabel(addressOption) }}</option>
                </select>
              </div>
            </div>
            <!-- Address line 1 -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="addressLine1">Address line 1*</label>
              <input #addressLine1="ngModel" class="form-control field-input"
                [class.is-invalid]="addressLine1.touched && !addressLine1.valid"
                id="addressLine1" name="addressLine1"
                [(ngModel)]="addressModel.addressLine1"
                placeholder="Address line 1"
                (blur)="addressModel.addressLine1 = addressModel.addressLine1.trim()"
                required type="text"/>
              <div *ngIf="addressLine1.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
            </div>
            <!-- Address line 2 -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="addressLine2">Address line 2</label>
              <input #addressLine2="ngModel" class="form-control field-input"
                id="addressLine2" name="addressLine2"
                [(ngModel)]="addressModel.addressLine2"
                placeholder="Address line 2"
                (blur)="addressModel.addressLine2 = addressModel.addressLine2.trim()"
                type="text"/>
            </div>
            <!-- Town/City -->
            <div class="d-flex flex-column gap-1 mb-3">
              <label class="field-label fw-medium" for="townPerCity">Town/City*</label>
              <input #townPerCity="ngModel" class="form-control field-input"
                [class.is-invalid]="townPerCity.touched && !townPerCity.valid"
                id="townPerCity" name="townPerCity"
                [(ngModel)]="addressModel.townPerCity"
                placeholder="Town/City" required type="text"/>
              <div *ngIf="townPerCity.invalid && townPerCity.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
            </div>
            <!-- Postcode -->
            <div class="d-flex flex-column gap-1">
              <label class="field-label fw-medium" for="postcode">Postcode*</label>
              <input #postcode="ngModel" class="form-control field-input"
                [class.is-invalid]="postcode.touched && !postcode.valid"
                id="postcode" name="postcode"
                [(ngModel)]="addressModel.postcode"
                placeholder="Postcode" required type="text"/>
              <div *ngIf="postcode.errors?.required" class="field-error small">{{ errorStrings.required }}</div>
            </div>
          </div>

        </div>

      </div>

      <!-- Submit -->
      <div class="d-flex justify-content-center mt-4">
        <button type="submit"
          class="btn btn-action fw-semibold"
          [disabled]="!ownerDetailForm.valid || loading">
          <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-2"></fa-icon>
          Next
        </button>
      </div>

    </form>
  </div>

  <app-background-icon
    src="/assets/images/icons/treats-pink.svg"
    [top]="20"
    [left]="15"
    [width]="175"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/carry_crate-pink.svg"
    [top]="20"
    [left]="60"
    [width]="230"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/cat-pink.svg"
    [top]="20"
    [left]="90"
    [width]="300"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/kennel-pink.svg"
    [top]="60"
    [left]="5"
    [width]="140"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/medicine-pink.svg"
    [top]="95"
    [left]="20"
    [width]="210"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/paw-pink.svg"
    [top]="80"
    [left]="95"
    [width]="130"
    [opacity]="0.5"
  />

</section>
